import { useState, useEffect, useCallback } from 'react'
import { useVestigioService } from 'hooks/useVestigioService'

export const useDescricoesVestigiosExame = ({ idExameSolicitado }) => {
  const vestigioService = useVestigioService()
  const [vestigios, setVestigios] = useState([])
  const [processandoVestigios, setProcessandoVestigios] = useState(false)

  const fetchVestigiosDeExameSolicitado = useCallback(async () => {
    if (idExameSolicitado) {
      setProcessandoVestigios(true)
      try {
        const response = await vestigioService.listarVestigiosDeExameSolicitadoAsync(
          idExameSolicitado,
          setProcessandoVestigios
        )
        setVestigios(response || [])
      } catch (error) {
        console.error('Error fetching vestígios of requested exam:', error)
      } finally {
        setProcessandoVestigios(false)
      }
    }
  }, [idExameSolicitado])

  useEffect(() => {
    fetchVestigiosDeExameSolicitado()
  }, [fetchVestigiosDeExameSolicitado])

  return {
    vestigios,
    processandoVestigios,
    fetchVestigiosDeExameSolicitado,
  }
}
